// NotificationBell.js — admin panel ust barinda CAN + uyari sayaci
//
// Serkan (17 Agu 2026): "Egitim sureleri bitmeye yakin uyari versin dedik ama
//  nasil verecek onu konusmadik. Admin panelde bir notification olsun, RING BELL
//  imaji yaninda kirmizi/amber flag; tiklayinca popup ekran ciksin ve soyle olsun
//  mesela: 'Serkan CALISKAN XXX egitimi expire olacak within xx days'."
//
// NEDEN AYRI BILESEN: uyari FTL sekmesinin ICINDE kalirsa yalniz oraya giren
// gorur. Egitim suresi ise gorev atarken degil, HERHANGI BIR AN farkedilmesi
// gereken bir sey — o yuzden ust barda, her sekmede.
//
// HESAP TrainingRules.js'ten gelir: esikler (60/30/15) ve gecerlilik kurallari
// TEK KAYNAKTIR. Bu bilesen kendi tarih matematigini YAPMAZ; yapsaydi TRAINING
// sekmesiyle can farkli gun sayilari gosterebilirdi (Ilke 3).
//
// GIRILMEMIS EGITIM UYARI URETMEZ (Serkan): kaydi olmayan kalem icin cana
// hicbir sey dusmez. Can yalniz VAR OLAN kayitlarin suresini izler.
//
// ┌ 19 AGU 2026 — UC KADEME ───────────────────────────────────────────────┐
// │ Serkan: "60-30 arasi sari, 30-15 arasi amber, 15-0 kirmizi."           │
// │ Onceki surumde can KENDI iki renkli mantigini kuruyordu:               │
// │   renk = worst >= 3 ? red : amber                                      │
// │ Sonuc: 45 gun kala da 20 gun kala da AYNI sari. Ekranda uc kademe      │
// │ vardi ama canda iki. Artik renk STATE_COLOR'dan okunur (Ilke 3) —      │
// │ can hicbir renk/tarih karari VERMEZ, yalnizca gosterir.                │
// │                                                                        │
// │ · Canin kendi rengi EN YUKSEK ONCELIGE gore (worstState):              │
// │   50 gun + 43 gun + 5 gun -> KIRMIZI.                                  │
// │ · Acilan listede HER EGITIM KENDI renginde.                            │
// │ · Liste oncelik sirasinda: kirmizi -> amber -> sari; esitse az gun     │
// │   kalan ustte.                                                         │
// │ · Suresi gecmis kalemin USTUNDE EXPIRED rozeti (renk ayni kirmizi,     │
// │   ayrimi yazi tasir).                                                  │
// └────────────────────────────────────────────────────────────────────────┘
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { supabase } from '../supabaseClient';
import { pfRecency } from './FTLEngine';
import { caniIlgilendiren } from './LicenceAlerts';
// 🔑 ŞİRKETİN yerel günü (21 Eyl 2026, Serkan: *"ana üs yereli"*).
import { useSirketDilimi } from './sirketDilimi';
import {
  trainingStatus, todayLocal, STATE_COLOR, STATE_RANK, worstState, ALERT_DAYS,
  latestPerTraining,
} from './TrainingRules';
import { skpkAlerts, fmtMin } from './FTLEngine';
import { BILDIRIM_TAZELE } from './bildirimOlayi';
import { vh } from '../yaziBoyutu';
import { usePencereKapat } from './pencereKapat';   // açılır uyarı kutusu ESC ile kapanır (12 Eki 2026)
import { SAYILI, hepsiniOku, okunamadiMi } from './kesikOkuma';   // 24 ay şartı — parça parça, kesik okuma = okunamadı (6 Eki 2026)

const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)', border2:'var(--border2)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)',
};

export default function NotificationBell({ customerId, onOpenDuty }) {
  // Yoklama her 5 dk KENDİ KAPANIŞINDA koşuyor; dilim oraya `ref` ile girer,
  // yoksa yoklama ilk kurulduğu andaki (henüz null) değeri taşırdı.
  const dilim = useSirketDilimi();
  const dilimRef = useRef(null);
  useEffect(() => { dilimRef.current = dilim.tz; }, [dilim.tz]);
  const [items, setItems] = useState([]);
  // ── FDP ASIMI — RAPORU YAZILMAMIS SKPK OLAYLARI (26 Agu 2026) ──────────
  //
  // 🔑 Serkan: *"Ucus uzadi, actual saatler SKPK yapmayi gerektirdi. Zilde
  //    KIRMIZI notification olsun, ilgili ucusu gosterip rapor yaz uyarisi
  //    ciksin; rapor yazinca uyari kalksin."*
  //
  // 🔑 KURAL GOREVIN KENDI SNAPSHOT'INDAN OKUNUR (`ruleset_snapshot`), bugunku
  // ruleset'ten DEGIL — gorev hangi kurallarla planlandiysa onlara tabidir.
  // Ayrica ikinci bir tablo cekmemis oluyoruz: tek kaynak, tek sorgu.
  //
  // 🔒 YAZMA YOLU ACILMADI: can yalnizca GOSTERIR ve ilgili goreve GOTURUR.
  // SKPK kaydini yazan tek yer FTL panelindeki EDIT akisidir (orada uzatma,
  // `skpk_ref`, 1 saat esigi ve 28 gunluk SHGM tarihi motordan geliyor).
  // Buraya ikinci bir yazma yolu koysaydik ayni mevzuat hesabi iki yerde
  // durur ve er ya da gec ayrisirdi (Ilke 3).
  const [skpk, setSkpk] = useState([]);
  // ── SON DÖNEM TECRÜBESİ (4 Eyl 2026, Serkan) ──────────────────────────
  // 🔑 *"60'dan sonra notification da versin, yukarıda aynı renk kodlarıyla —
  //    diyelim ki 2 sarı 1 kırmızı not var, o zaman zil kırmızı olsun."*
  // Zil zaten EN KÖTÜ kalemi alıyor; yeni bir mekanizma değil, yeni bir
  // KAYNAK. Görev sorgusu `sectors` ile zaten çekiliyor — ek sorgu YOK.
  const [recency, setRecency] = useState([]);
  // ── LİSANS / SAĞLIK TARİHLERİ (5 Eyl 2026, Serkan) ────────────────────
  // 🔑 *"ir_valid_until / elp_valid_until / examiner_until zile düşsün."*
  // Eşikler ATPL & MED'de DEĞİL, TrainingRules'ta — aynı 60/30/15.
  const [lisans, setLisans] = useState([]);
  const [open, setOpen] = useState(false);
  usePencereKapat(() => setOpen(false), open);
  // OKUNAMADI durumu — Serkan (19 Agu): "kopma olursa ring bell uzerine cross
  // line olsun (not avail)". Bos liste ile OKUNAMADI ayri seylerdir; ikisine
  // ayni ekrani basmak "hepsi temiz" yalanidir (Ilke 1).
  const [okunamadi, setOkunamadi] = useState(false);
  // Son BASARILI okumanin saati. null ise hic okunamadi (giriste dustu).
  const [sonOkuma, setSonOkuma] = useState(null);

  // customerId YALNIZ super admin baska sirketi izlerken dolu gelir. Normal
  // adminde null'dir ve filtre uygulanmaz — RLS zaten kendi sirketine kisitlar
  // (AdminPanel'in geri kalaninda da desen bu).
  const load = useCallback(async () => {
    const scope = (q) => customerId ? q.eq('customer_id', customerId) : q;

    // KRONOLOJIK KURAL: status='current' filtresi KALDIRILDI. Hangi kaydin
    // gecerli oldugunu damga degil TARIH soyler (bkz. TrainingRules
    // latestPerTraining). Butun kayitlar cekilir, gecerli olan turetilir.
    // Secilen kolonlar: date_of_birth CEKILMEZ (KVKK — cana lazim degil).
    // 🔴 6 Eki 2026 (24 ay şartı, 2c-1): görevler ve eğitimler bütün geçmişle okunur — tek istekte okununca sunucu
    //    sınırında SESSİZCE kesilirdi (eksik görev listesiyle SKPK / PF yakınlığı yanlış hesaplanır). Şimdi ikisi
    //    PARÇA PARÇA (`hepsiniOku`); her okuma toplamı da ister ve KESİK gelen okuma DÜŞMÜŞ sayılır (`okunamadiMi`):
    //    o bölüm "boş" değil BİLİNMİYOR olur — Serkan: *"yarım yamalak veri olmaz"*.
    let trn, cat, profs, gorevler, lisansSatirlari;
    try {
      const [a, b, c, plm, dd] = await Promise.all([
        hepsiniOku(() => scope(supabase.from('pilot_trainings')
          .select('id,pilot_id,training_code,completed_date,expires_at,created_at,status', SAYILI))),   // status: silinen kayıt uyarı üretmez (13 Eki 2026)
        scope(supabase.from('training_catalog').select('code,name', SAYILI)),
        scope(supabase.from('profiles').select('id,code,full_name', SAYILI)),
        scope(supabase.from('pilot_licence_med').select(
          'pilot_id,date_of_birth,ir_valid_until,elp_level,elp_valid_until,'
          + 'examiner_until,med_class,med_exam_date,created_at', SAYILI)),
        hepsiniOku(() => scope(supabase.from('crew_duties').select(
          'id,pilot_id,duty_type,status,duty_date,duty_end,fdp_minutes,max_fdp_minutes,'
          + 'skpk_reason,skpk_fdp_extension_min,sectors,ruleset_snapshot', SAYILI))),
      ]);
      gorevler = okunamadiMi(dd) ? null : (dd.data || []);
      // 🔑 Supabase hatayi FIRLATMAZ, { error } olarak DONDURUR (Ilke 2).
      // Onceki surumde bu alan hic okunmuyordu: sorgu duserse data null gelir,
      // liste bosalir ve ekranda "NO TRAINING EXPIRING WITHIN 60 DAYS" yazardi
      // — yani "bakamadim" yerine "bakacak bir sey yok".
      if (okunamadiMi(a) || okunamadiMi(b) || okunamadiMi(c)) { setOkunamadi(true); return; }
      [trn, cat, profs] = [a.data, b.data, c.data];
      // Pilot basina EN YENI satir gecerlidir (Ilke 4).
      const enYeni = {};
      (okunamadiMi(plm) ? [] : (plm.data || []))
        .sort((x, y) => new Date(y.created_at) - new Date(x.created_at))
        .forEach(r => { if (!enYeni[r.pilot_id]) enYeni[r.pilot_id] = r; });
      lisansSatirlari = okunamadiMi(plm) ? null : enYeni;
    } catch {
      // Ag koptuysa istemci bazi surumlerde firlatir — o yol da kapali kalsin.
      setOkunamadi(true); return;
    }

    const catBy = Object.fromEntries((cat || []).map(c => [c.code, c]));
    const pBy   = Object.fromEntries((profs || []).map(p => [p.id, p]));

    // Gorev okumasi dusse bile EGITIM uyarilari gosterilir; ama SKPK listesi
    // "bos" degil BILINMIYOR olur — bos listeyi temiz sanmak Ilke 1 ihlali.
    // Pilot eslemesi BURADA yapilir: `pBy` ancak bu satirda hazir.
    setSkpk(gorevler === null ? null : gorevler.flatMap(
      d => skpkAlerts([d], d.ruleset_snapshot?.regulation)
             .map(a => ({ ...a, pilot: pBy[d.pilot_id] }))));
    // Yakınlık: yalnız DİKKAT İSTEYEN kademeler cana düşer (60 günden önce
    // sessiz — Serkan'ın eşiği). Görev okuması düştüyse liste BOŞ değil
    // BİLİNMİYOR olur; boşu temiz sanmak İlke 1 ihlalidir.
    setRecency(gorevler === null ? null : (profs || []).map(p => {
      const r = pfRecency(gorevler, p.id, new Date());
      return { pilot: p, r, st: { state: r.state === 'red' ? 'CRITICAL' : 'WARNING' } };
    // 'unknown' = hic kayit yok → OLCMEDIK, cana dusmez (Ilke 1).
    }).filter(x => x.r.state === 'amber' || x.r.state === 'red'));

    // YEREL takvim gunu (Serkan: "bu sayac lokal gun takip etmeli"). Yoklama
    // her 5 dk kostugu icin gun degisince sayac kendiliginden duser; sayi
    // hicbir yerde SAKLANMAZ, her seferinde expires_at'ten turetilir (Ilke 3).
    // 🔑 21 Eki 2026 (Serkan: "bilgisayarın günü değil ana üs günü olmalı"): lisans/sağlık uyarıları da AYNI gün —
    //    önce `caniIlgilendiren(r)` gün almıyor, ekrana bakılan cihazın gününe düşüyordu (eğitim uyarıları ana üs günündeydi).
    const t = todayLocal(dilimRef.current);

    // Lisans/saglik tarihleri — okuma DUSTUYSE liste BOS degil BILINMIYOR.
    setLisans(lisansSatirlari === null ? null
      : Object.entries(lisansSatirlari).flatMap(([pid, r]) =>
          caniIlgilendiren(r, t).map(x => ({ ...x, pilot: pBy[pid] }))));

    // Esik artik kayittan/katalogdan degil TrainingRules'tan: sabit 60/30/15.
    const list = latestPerTraining(trn).map(r => ({
      ...r,
      st: trainingStatus(r.expires_at, t),
      pilot: pBy[r.pilot_id],
      catName: catBy[r.training_code]?.name,
    }))
    // VALID ve NO_EXPIRY cana dusmez — can yalniz DIKKAT isteyeni tasir.
    .filter(x => STATE_RANK[x.st.state])
    // ONCELIK SIRASI (Serkan): kirmizi -> amber -> sari; esit kademede az gun
    // kalan ustte. Yani en acil olan her zaman en ustte.
    .sort((a, b) => (STATE_RANK[b.st.state] - STATE_RANK[a.st.state])
                 || (a.st.daysLeft - b.st.daysLeft));

    setItems(list);
    setSonOkuma(new Date().toTimeString().slice(0, 5));   // HH:MM, yerel
    setOkunamadi(false);
  }, [customerId]);

  useEffect(() => { load(); const iv = setInterval(load, 300000); return () => clearInterval(iv); }, [load]);
  // ── KAYIT OLUNCA HEMEN (29 Eyl 2026) ─────────────────────────────────
  // 🔑 Serkan: *"Eğitim güncelledim, sayacın doğru çalışması için sayfa
  //    yenilemek gerekti."* TRAINING, ATPL & MED ve FTL kayıtları başarılı
  //    olunca `bildirimleriTazele()` olayı atar; zil beklemeden yeniden okur.
  //    5 dakikalık yoklama YEDEK olarak durur (başka sekme / başka kullanıcı).
  useEffect(() => {
    window.addEventListener(BILDIRIM_TAZELE, load);
    return () => window.removeEventListener(BILDIRIM_TAZELE, load);
  }, [load]);

  // Canin rengini EN YUKSEK ONCELIKLI kalem belirler (Serkan): 50g + 43g + 5g
  // -> KIRMIZI. Renk STATE_COLOR'dan gelir, burada renk KARARI verilmez.
  // Yakınlık kalemleri de aynı sözlükten konuşur (WARNING/CRITICAL), böylece
  // "en kötü kazanır" kuralı ikisini birden kapsar — ayrı bir renk kararı YOK.
  // useMemo: aksi halde her cizimde YENI dizi olur ve asagidaki useMemo'nun
  // bagimliligi surekli degisir (build kapisi bunu hata sayiyor).
  const recList = useMemo(() => (Array.isArray(recency) ? recency : []), [recency]);
  const lisList = useMemo(() => (Array.isArray(lisans) ? lisans : []), [lisans]);
  // Aynı sorgudan gelen kalemler İKİ AYRI mevzuata ait: IR/ELP/EXAMINER
  // SHT-FCL'dendir, sağlık geçerliliği SHT-MED'den. Tek başlık altında
  // toplamak, hangi kuralın konuştuğunu gizlerdi.
  const fclList = useMemo(() => lisList.filter(x => x.key !== 'med'), [lisList]);
  const medList = useMemo(() => lisList.filter(x => x.key === 'med'), [lisList]);
  /** Bölüm başlığı — kalemler hangi kural setinden geliyorsa onu söyler. */
  const Bolum = ({ baslik, kunye, adet }) => (adet ? (
    <div style={{ padding:'7px 16px', background:C.bg3,
                  borderBottom:`1px solid ${C.border}`, display:'flex',
                  justifyContent:'space-between', alignItems:'center' }}>
      <span style={{ fontSize:9.5, fontWeight:700, letterSpacing:1.6, color:C.t2,
                     fontFamily:'var(--mono)', textTransform:'uppercase' }}>{baslik}</span>
      <span style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)', letterSpacing:1 }}>{kunye}</span>
    </div>
  ) : null);

  /** Lisans ve sağlık kalemleri AYNI biçimde çizilir. */
  const lisansSatiri = (x) => {
    const c = STATE_COLOR[x.st.state];
    return (
      <div key={`lis-${x.pilot?.id}-${x.key}`} data-testid="licence-alert"
           data-durum={x.st.state}
           style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`,
                    borderLeft:`3px solid ${c}` }}>
        <div style={{ fontSize:11, fontWeight:700, color:c, fontFamily:'var(--mono)' }}>
          {adi(x.pilot)} — {x.kod}
        </div>
        <div style={{ fontSize:11, color:C.t2, marginTop:3 }}>
          {x.ad} · {x.st.state === 'EXPIRED'
            ? `EXPIRED ${Math.abs(x.st.daysLeft)} day(s) ago (${x.expires})`
            : x.st.daysLeft == null
              ? 'cannot be calculated'
              : `expires in ${x.st.daysLeft} day(s) (${x.expires})`}
        </div>
        <div style={{ fontSize:10, color:C.t3, marginTop:2, fontFamily:'var(--mono)' }}>
          {x.ref} · entered in ATPL &amp; MED
        </div>
      </div>
    );
  };

  const worst = useMemo(
    () => worstState([...items.map(x => x.st.state), ...recList.map(x => x.st.state),
                      ...lisList.map(x => x.st.state)]),
    [items, recList, lisList]);
  // FDP asimi HER ZAMAN KIRMIZIDIR (Serkan: "mutlaka kirmizi"): kademesi yok,
  // rapor ya yazilmistir ya yazilmamistir. Bir tane bile varsa can kirmizidir.
  const skpkVar = Array.isArray(skpk) && skpk.length > 0;
  // OKUNAMADI ise renk YOK: bilmedigimiz seye renk vermeyiz (Ilke 1).
  const renk  = okunamadi ? null
              : skpkVar ? STATE_COLOR.CRITICAL
              : (worst ? STATE_COLOR[worst] : null);
  const toplam = (Array.isArray(skpk) ? skpk.length : 0) + items.length + recList.length + lisList.length;

  const adi = (p) => p ? `${p.code ? p.code + ' — ' : ''}${(p.full_name || '').toUpperCase()}` : 'UNKNOWN PILOT';
  const metin = (x) =>
    x.st.state === 'EXPIRED'
      ? `${adi(x.pilot)} — ${x.training_code} EXPIRED ${Math.abs(x.st.daysLeft)} days ago (${x.expires_at})`
      : `${adi(x.pilot)} — ${x.training_code} will expire within ${x.st.daysLeft} days (${x.expires_at})`;

  return (
    <div style={{ position:'relative' }}>
      <button
        onClick={() => setOpen(o => !o)}
        title={okunamadi
          ? `Training alerts not available${sonOkuma ? ` — last read ${sonOkuma}` : ''}`
          : (toplam ? `${toplam} alert(s)` : 'No alerts')}
        // Canin o anki durumu OKUNABILIR sekilde isaretlenir. Renk `var(--red)`
        // gibi degiskenlerle verildigi icin testten okunamiyor; bu isaret hem
        // render testinin "en yuksek oncelik rengi belirliyor mu" sorusunu
        // cevaplamasini saglar hem sahada hata ayiklamayi kolaylastirir.
        data-durum={okunamadi ? 'NOT_AVAILABLE' : (skpkVar ? 'CRITICAL' : (worst || 'NONE'))}
        style={{ position:'relative', width:34, height:34, background:'transparent',
                 border:`1px solid ${C.border2}`, borderRadius:6, color: renk || C.t3,
                 fontSize:15, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center',
                 opacity: okunamadi ? .65 : 1 }}>
        🔔
        {/* CAPRAZ CIZGI = NOT AVAILABLE (Serkan, 19 Agu). Okuma dustugu surece
            durur, ilk basarili okumada kendiliginden kalkar. */}
        {okunamadi && (
          <span style={{ position:'absolute', left:4, right:4, top:'50%', height:2,
                         background:C.t2, borderRadius:1, transform:'rotate(-45deg)',
                         boxShadow:'0 0 0 1px var(--bg2)' }} />
        )}
        {/* Sayac OKUNAMADI'da GIZLENIR: "0" da bir iddiadir, bilmedigimizi
            sayiya dokmeyiz — capraz cizgiyi curuturdu. */}
        {!okunamadi && toplam > 0 && (
          <span style={{ position:'absolute', top:-6, right:-6, minWidth:16, height:16, padding:'0 4px',
                         borderRadius:8, background:renk, color:'#fff', fontSize:9, fontWeight:700,
                         fontFamily:'var(--mono)', display:'flex', alignItems:'center', justifyContent:'center' }}>
            {toplam}
          </span>
        )}
      </button>

      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position:'fixed', inset:0, zIndex:70 }} />
          <div style={{ position:'absolute', right:0, top:42, width:460, maxHeight:vh(70), overflowY:'auto',
                        background:C.bg2, border:`1px solid ${C.border2}`, borderRadius:10,
                        boxShadow:'var(--shadow)', zIndex:71 }}>
            <div style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`, background:C.bg3,
                          display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:renk || C.t2,
                             textTransform:'uppercase', fontFamily:'var(--mono)' }}>
                {/* 🔑 Serkan (6 Eyl 2026): *"Burada sadece training alert
                    olmasın; burada FCL ve MED alerts de olmalı — tek uyarı
                    kapısı, başlıkları farklı olur."*
                    🔴 Kutu ZATEN lisans ve sağlık kalemlerini gösteriyordu ama
                    başlığı "TRAINING ALERTS" diyordu: IR uyarısı Training
                    başlığı altında duruyordu. Kalemi yanlış künyeyle göstermek,
                    okuyanı yanlış kural setine yönlendirir (İlke 1). */}
                {skpkVar ? 'Alerts' : 'Crew alerts'}
              </span>
              {/* Esikler TrainingRules'tan basilir — ekranda yazan sayi ile
                  hesabin kullandigi sayi ayrisamaz (Ilke 3). */}
              <span style={{ fontSize:9, color:C.t3, fontFamily:'var(--mono)', letterSpacing:1 }}>
                {okunamadi
                  ? 'NOT AVAILABLE'
                  : `${ALERT_DAYS.NOTICE} / ${ALERT_DAYS.WARNING} / ${ALERT_DAYS.CRITICAL} DAYS`}
              </span>
            </div>

            {/* OKUNAMADI — "uyari yok" cumlesi BURADA ASLA YAZILMAZ.
                Elde onceki bir liste varsa atmayiz: "14:20 itibariyla sunlar
                vardi" bilgisi hala degerlidir; ama TAZE SANILMASIN diye saat
                damgasi ustunde durur ve liste soluklastirilir. */}
            {okunamadi && (
              <div style={{ padding:'14px 16px', fontSize:11, fontFamily:'var(--mono)',
                            lineHeight:1.8, color:C.t2, background:'var(--hover)',
                            borderBottom:`1px solid ${C.border}` }}>
                NOT AVAILABLE — COULD NOT READ<br />
                <span style={{ color:C.t3 }}>
                  {sonOkuma
                    ? `Showing last successful read at ${sonOkuma}. Retrying every 5 minutes.`
                    : 'No reading has succeeded yet. Retrying every 5 minutes.'}
                </span>
              </div>
            )}

            {/* ── FDP ASIMI — EN USTTE, KIRMIZI ────────────────────────────
                Geri sayim Md.12(1)(c)(2)'den: uzatma 1 SAATI ASIYORSA kaptan
                raporunun bir kopyasi olaydan itibaren 28 GUN icinde SHGM'ye
                gonderilir. Asmiyorsa isletici kaydidir, SHGM'ye gitmez — o
                zaman GERI SAYIM DA YOKTUR; olmayan sureyi saymayiz.
                ⚠️ Metin "SKPK YAPILDI" demez: tavanin asilmasi takdirin
                kullanildigini kanitlamaz, onu KAPTAN beyan eder (Ilke 1). */}
            {skpk === null && (
              <div style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`,
                            fontSize:11, fontFamily:'var(--mono)', color:C.t2, lineHeight:1.7 }}>
                FDP ALERTS NOT AVAILABLE — COULD NOT READ DUTIES
              </div>
            )}
            {(skpk || []).map(a => {
              const gecti = a.gecti;   // tek hesap: son tarih geçti mi (sonTarihDurumu, 21 Eki 2026 K9)
              return (
                <div key={a.duty.id} data-testid="skpk-alert" data-durum="CRITICAL"
                     onClick={() => { if (onOpenDuty) { setOpen(false); onOpenDuty(a.duty.id); } }}
                     style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`,
                              borderLeft:`3px solid ${STATE_COLOR.CRITICAL}`,
                              cursor: onOpenDuty ? 'pointer' : 'default' }}>
                  <div style={{ display:'inline-block', marginBottom:5, padding:'1px 7px',
                                fontSize:9, fontWeight:700, letterSpacing:1.5,
                                fontFamily:'var(--mono)', color:'#fff',
                                background:STATE_COLOR.CRITICAL }}>
                    {gecti ? 'OVERDUE' : 'REPORT REQUIRED'}
                  </div>
                  <div style={{ fontSize:12, color:C.t1, fontFamily:'var(--mono)', lineHeight:1.5 }}>
                    {adi(a.pilot)} — FDP EXCEEDED {fmtMin(a.overshootMin)} on {a.duty.duty_date}
                    {' — COMMANDER\'S REPORT REQUIRED'}
                  </div>
                  <div style={{ marginTop:3, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)', lineHeight:1.6 }}>
                    {a.authorityRequired === true && a.daysLeft != null && (
                      <>Copy to the DGCA with the operator&apos;s comments — {a.authorityDays} days from
                        the event (SHT-FTL/HG Md.12(1)(c)(2)) · DUE {a.dueISO.slice(0, 10)} ·{' '}
                        <b style={{ color:STATE_COLOR.CRITICAL }}>
                          {a.kalanMetni}
                        </b></>
                    )}
                    {a.authorityRequired === false && (
                      <>Operator record only — no DGCA submission required
                        (extension ≤ {fmtMin(a.authorityOverMin)}, SHT-FTL/HG Md.12(1)(c))</>
                    )}
                    {a.authorityRequired == null && (
                      <>This duty&apos;s ruleset does not define the reporting deadline — due date not
                        calculated</>
                    )}
                    {onOpenDuty && <><br />Click to open the duty and record the report.</>}
                  </div>
                </div>
              );
            })}

            {!okunamadi && toplam === 0 && (
              // ILKE 1: "hersey yolunda" DEMEYIZ — neye bakildigini soyleriz.
              // Girilmemis egitim uyari uretmedigi icin bos liste "tam" anlamina
              // gelmez; kullanicinin bunu bilmesi gerekir.
              <div style={{ padding:'18px 16px', fontSize:11, color:C.t3, fontFamily:'var(--mono)', lineHeight:1.8 }}>
                NO TRAINING EXPIRING WITHIN {ALERT_DAYS.NOTICE} DAYS · NO FDP EXCEEDANCE AWAITING A REPORT<br />
                {/* ILKE 1: "hersey yolunda" DEMEYIZ — NEYE bakildigini soyleriz.
                    Can iki seyi izler: kayitli egitim sureleri ve raporu
                    yazilmamis FDP asimlari. Girilmemis egitim ve olculememis
                    gorev bu listeye hic girmez; kullanicinin bunu bilmesi sart. */}
                <span style={{ color:C.t2 }}>
                  Covers recorded trainings and measured duties only — items never entered,
                  and duties with no FDP limit recorded, are not tracked.
                </span>
              </div>
            )}

            {/* ── SON DÖNEM TECRÜBESİ (SHT-FCL FCL.060) ────────────────
                🔑 Serkan: *"60'dan sonra notification da versin, yukarıda aynı
                   renk kodlarıyla."*  Kalemler eğitimlerle AYNI sözlükten
                   konuşur (WARNING/CRITICAL) — zilin rengi ikisinin en kötüsü. */}
            {/* ── LİSANS / SAĞLIK TARİHLERİ (5 Eyl 2026) ────────────────
                🔑 Serkan: *"ir_valid_until / elp_valid_until / examiner_until
                   zile düşsün."*  Eşikler eğitimlerle AYNI (60/30/15) ve aynı
                   sözlükten renk alır — zil ikisinin en kötüsünü yakar. */}
            {/* Lisans ve sağlık AYNI sorgudan gelir ama İKİ AYRI mevzuattandır:
                IR/ELP/EXAMINER SHT-FCL'den, sağlık geçerliliği SHT-MED'den.
                Satır çizimi tek yerde — iki kopya yarın ayrışırdı (İlke 3). */}
            <Bolum baslik="Licence" kunye="SHT-FCL" adet={fclList.length} />
            {fclList.map(lisansSatiri)}
            <Bolum baslik="Medical" kunye="SHT-MED" adet={medList.length} />
            {medList.map(lisansSatiri)}

            <Bolum baslik="Recent experience" kunye="SHT-FCL FCL.060" adet={recList.length} />
            {recList.map(x => {
              const c = STATE_COLOR[x.st.state];
              return (
                <div key={`rec-${x.pilot.id}`} data-testid="recency-alert" data-durum={x.st.state}
                     style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`,
                              borderLeft:`3px solid ${c}` }}>
                  <div style={{ fontSize:11, fontWeight:700, color:c, fontFamily:'var(--mono)' }}>
                    {adi(x.pilot)} — RECENT EXPERIENCE
                  </div>
                  <div style={{ fontSize:11, color:C.t2, marginTop:3 }}>
                    {x.r.count < x.r.required
                      ? `Only ${x.r.count} PF sector(s) in the last ${x.r.windowDays} days — `
                        + `${x.r.required} required.`
                      : `The ${x.r.required}rd most recent PF sector is ${x.r.ageDays} day(s) old — `
                        + `${x.r.daysLeft} day(s) before the count drops below ${x.r.required}.`}
                  </div>
                  <div style={{ fontSize:10, color:C.t3, marginTop:2, fontFamily:'var(--mono)' }}>
                    {x.r.reference} · awareness only — night, FFS and type/class are not measured
                  </div>
                </div>
              );
            })}

            <Bolum baslik="Training" kunye="Operator programme" adet={items.length} />
            {items.map(x => {
              // HER EGITIM KENDI RENGINDE (Serkan): 50g sari, 43g sari, 5g kirmizi.
              // Renk tek kaynaktan — canin kendi esleme tablosu YOK.
              const c = STATE_COLOR[x.st.state];
              return (
                <div key={x.id} data-testid="training-alert" data-durum={x.st.state}
                     style={{ padding:'11px 16px', borderBottom:`1px solid ${C.border}`,
                                         borderLeft:`3px solid ${c}`,
                                         opacity: okunamadi ? .45 : 1 }}>
                  {/* Suresi GECMIS kalem CRITICAL ile ayni kirmizidir; ayrimi
                      renk degil bu rozet tasir (Serkan: "ustunde EXPIRED yazsin"). */}
                  {x.st.state === 'EXPIRED' && (
                    <div style={{ display:'inline-block', marginBottom:5, padding:'1px 7px',
                                  fontSize:9, fontWeight:700, letterSpacing:1.5,
                                  fontFamily:'var(--mono)', color:'#fff', background:c }}>
                      EXPIRED
                    </div>
                  )}
                  <div style={{ fontSize:12, color:C.t1, fontFamily:'var(--mono)', lineHeight:1.5 }}>
                    {metin(x)}
                  </div>
                  <div style={{ marginTop:3, fontSize:9.5, color:C.t3, fontFamily:'var(--mono)' }}>
                    {x.catName || x.training_code}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
